import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "tw-flex tw-items-center tw-justify-between tw-mb-6" };
const _hoisted_2 = { class: "tw-max-w-[200px]" };
const _hoisted_3 = { class: "tw-flex tw-gap-3" };
const _hoisted_4 = {
    key: 0,
    class: "tw-relative tw-w-[70%] tw-h-[calc(100vh-180px)]"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = {
    ref: "sentinel",
    class: "tw-h-10 tw-bg-transparent"
};
import { ref, computed } from "vue";
import { usePopupStore } from "@/stores/popup";
export default /*@__PURE__*/ _defineComponent({
    __name: 'GamesByProviders',
    props: {
        games: {},
        selectedCategory: {},
        isLoading: { type: Boolean }
    },
    emits: ["viewGames"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const searchQuery = ref("");
        const gameUrl = ref(null);
        const scrollContainer = ref(null);
        // Computed property to filter games based on searchQuery
        const filteredGames = computed(() => {
            return props.games.filter(game => game.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
        });
        const handleGameClick = (game) => {
            if (!localStorage.getItem("user")) {
                usePopupStore().showPopup("login");
                return;
            }
            const url = `https://arabianbet.net/game/${game.name}?api_exit=/`;
            window.innerWidth < 768 ? window.open(url, "_blank") : (gameUrl.value = url);
        };
        const closeGame = () => (gameUrl.value = null);
        return (_ctx, _cache) => {
            const _component_CardTitle = _resolveComponent("CardTitle");
            const _component_CardContent = _resolveComponent("CardContent");
            const _component_Card = _resolveComponent("Card");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_CardTitle, { class: "!tw-text-[18px] tw-mb-0 tw-text-center" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.selectedCategory?.title || "All"), 1)
                        ]),
                        _: 1
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                            type: "text",
                            placeholder: "Search Games",
                            class: "tw-border tw-border-solid tw-px-4 tw-text-sm tw-py-1"
                        }, null, 512), [
                            [_vModelText, searchQuery.value]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    (gameUrl.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("button", {
                                class: "tw-absolute tw-top-2 tw-right-2 tw-bg-red-500 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-text-sm tw-font-bold",
                                onClick: closeGame
                            }, " Close "),
                            _createElementVNode("iframe", {
                                src: gameUrl.value,
                                frameborder: "0",
                                class: "tw-w-full tw-h-full"
                            }, null, 8, _hoisted_5)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: _normalizeClass(gameUrl.value ? 'tw-w-[30%]' : 'tw-w-full')
                    }, [
                        _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-col-span-full tw-xl:col-span-4 tw-w-full tw-bg-transparent" }, {
                            default: _withCtx(() => [
                                (filteredGames.value.length)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        ref_key: "scrollContainer",
                                        ref: scrollContainer,
                                        class: "tw-max-h-[calc(100vh-180px)] tw-overflow-auto"
                                    }, [
                                        _createVNode(_component_CardContent, { class: "scroller tw-grid tw-grid-cols-3 lg:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-5 tw-gap-4" }, {
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGames.value, (game) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: game.id
                                                    }, [
                                                        _createElementVNode("div", {
                                                            class: "tw-flex tw-items-center tw-gap-4 tw-rounded tw-cursor-pointer tw-w-full tw-h-full",
                                                            onClick: ($event) => (handleGameClick(game))
                                                        }, [
                                                            _createElementVNode("img", {
                                                                src: `https://arabianbet.net/frontend/Default/ico/${game.name}.jpg`,
                                                                alt: game.name,
                                                                class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                            }, null, 8, _hoisted_7)
                                                        ], 8, _hoisted_6)
                                                    ]));
                                                }), 128)),
                                                _createElementVNode("div", _hoisted_8, null, 512)
                                            ]),
                                            _: 1
                                        })
                                    ], 512))
                                    : _createCommentVNode("", true),
                                (_ctx.isLoading)
                                    ? (_openBlock(), _createBlock(_component_CardContent, {
                                        key: 1,
                                        class: "tw-grid tw-grid-cols-3 md:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-6 tw-gap-5 tw-mt-6"
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                                                return _createElementVNode("div", {
                                                    key: 'skeleton-' + index,
                                                    class: "tw-flex tw-items-center tw-gap-4 tw-rounded tw-animate-pulse"
                                                }, _cache[1] || (_cache[1] = [
                                                    _createElementVNode("div", { class: "tw-bg-gray-300 tw-rounded-md md:tw-h-32 tw-h-[70px] tw-w-full" }, null, -1)
                                                ]));
                                            }), 64))
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ], 2)
                ])
            ], 64));
        };
    }
});
